import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import {MatCardModule} from "@angular/material/card";
import {MatButtonModule} from "@angular/material/button";
import {SafePipeModule} from "@signature-it/ngx-generic/pipes";
import {SpinElDirectiveModule} from "@signature-it/ngx-generic/directives";
import {MatExpansionModule} from "@angular/material/expansion";
import {TreeAccordionComponentGeneric} from "./tree-accordion.component";


@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        MatCardModule,
        MatButtonModule,
        SafePipeModule,
        MatExpansionModule,
        SpinElDirectiveModule,
    ],

    declarations: [TreeAccordionComponentGeneric],
    exports: [TreeAccordionComponentGeneric],
})
export class TreeAccordionModuleGeneric {}
